import { render } from "./Organisations.vue?vue&type=template&id=9e0d9b5e"
import script from "./Organisations.vue?vue&type=script&lang=js"
export * from "./Organisations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__